
import MHeader from '../../Header/Header.vue';
import NotData from '../../NoData/NoData.vue';
import Scroller from 'vux/src/components/scroller/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'

import {
getMyFinalNumberList
} from '../../../api';
export default {
components: {
MHeader,
NotData,
Scroller,
XImg,
LoadMore,
},
data() {
return {
page_size: "10",
page_no: "0",
data: [],
h: "",
isLoad: true,
isMore: true
}
},
methods: {
onScrollBottom() {
if (this.isLoad) {
this.page_no++;
this.getList();
};
},
toDetail(id) {
this.$router.push({
name: 'winningDetail',
params: {
rob_id: id
}
})
},
getList() {
this.isLoad = false;
getMyFinalNumberList(`page_size=${this.page_size}&page_no=${this.page_no}`).then(res => {
if (res.data.error_code) {
this.$router.go(-1);
console.error(res);
return;
};
console.log(this.data);
if (res.data.data) {
this.data = this.data.concat(res.data.data);
this.isLoad = true;
} else {
this.isMore = false;
};

if (res.data.data && res.data.data.length < 10) {
this.isMore = false;
}
if (!this.page_no) {
this.$nextTick(() => {
this.$refs.scrollerBottom.reset()
});
}


});
}
},
mounted() {},
created() {
this.h = document.documentElement.clientHeight - parseInt(document.documentElement.style.fontSize) * 0.88 + 'px';
this.getList();
}
};



// WEBPACK FOOTER //
// ./src/components/UserCenter/winning/winning.vue